import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { FC } from "react";
import NavigationSection from "@/components/NavigationSection";
import "rc-slider/assets/index.css";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import RangeSlider from "@/components/RangeSlider";
import {
  SizeFormField,
  SizeRangeSliderMax,
  SizeRangeSliderMin,
  SizeRangeSliderStep,
  SizeRangeSliderUnit,
} from "@/consts/RangeSlider";
import useRangeSlider from "@/hooks/useRangeSlider";

interface Props {
  query: ProductSearchQueryParameter;
  queryController: SearchQueryParameterController<SizeFormField>;
}

const NavigationSectionSize: FC<Props> = ({
  query,
  queryController,
}): JSX.Element => {
  const widthSlider = useRangeSlider({
    defaultMin: query.min_width,
    defaultMax: query.max_width,
    min: SizeRangeSliderMin,
    max: SizeRangeSliderMax,
    onUpdate: () => {
      queryController.addQuery("min_width", widthSlider.minQueryValue);
      queryController.addQuery("max_width", widthSlider.maxQueryValue);
      queryController.submitQuery();
    },
  });

  const heightSlider = useRangeSlider({
    defaultMin: query.min_height,
    defaultMax: query.max_height,
    min: SizeRangeSliderMin,
    max: SizeRangeSliderMax,
    onUpdate: () => {
      queryController.addQuery("min_height", heightSlider.minQueryValue);
      queryController.addQuery("max_height", heightSlider.maxQueryValue);
      queryController.submitQuery();
    },
  });

  const depthSlider = useRangeSlider({
    defaultMin: query.min_depth,
    defaultMax: query.max_depth,
    min: SizeRangeSliderMin,
    max: SizeRangeSliderMax,
    onUpdate: () => {
      queryController.addQuery("min_depth", depthSlider.minQueryValue);
      queryController.addQuery("max_depth", depthSlider.maxQueryValue);
      queryController.submitQuery();
    },
  });

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    queryController.addQuery("min_width", widthSlider.minQueryValue);
    queryController.addQuery("max_width", widthSlider.maxQueryValue);
    queryController.addQuery("min_height", heightSlider.minQueryValue);
    queryController.addQuery("max_height", heightSlider.maxQueryValue);
    queryController.addQuery("min_depth", depthSlider.minQueryValue);
    queryController.addQuery("max_depth", depthSlider.maxQueryValue);
    queryController.submitQuery();
  };

  return (
    <NavigationSection
      title={`サイズ`}
      defaultOpen={
        !!query.min_width ||
        !!query.max_width ||
        !!query.min_height ||
        !!query.max_height ||
        !!query.min_depth ||
        !!query.max_depth
      }
    >
      <form onSubmit={onSubmit}>
        <ul className="space-y-4 text-sm">
          <li>
            <div className="space-y-24">
              <div className="space-y-8">
                <p className="font-bold text-xs">幅</p>
                <RangeSlider
                  rangeSlider={widthSlider}
                  step={SizeRangeSliderStep}
                  unit={SizeRangeSliderUnit}
                />
              </div>

              <div className="space-y-8">
                <p className="font-bold text-xs">高さ</p>
                <RangeSlider
                  rangeSlider={heightSlider}
                  step={SizeRangeSliderStep}
                  unit={SizeRangeSliderUnit}
                />
              </div>

              <div className="space-y-8">
                <p className="font-bold text-xs">奥行き</p>
                <RangeSlider
                  rangeSlider={depthSlider}
                  step={SizeRangeSliderStep}
                  unit={SizeRangeSliderUnit}
                />
              </div>
            </div>
          </li>
        </ul>
        <input type="submit" className="hidden" />
      </form>
    </NavigationSection>
  );
};
export default NavigationSectionSize;
